import React from 'react';

import { Table } from 'react-bootstrap';

import {OrderHistoryRecord} from "../../../types/Order";

import OrderHistoryRow from './components/OrderHistoryRow';


type Props = {
  historyRecords: OrderHistoryRecord[],
  tz?:string;
}
const OrderHistory = (props:Props) => (
  <Table responsive>
    <thead>
    <tr>
      <th>Date</th>
      <th>Status</th>
      <th>Updated By</th>
      <th />
    </tr>
    </thead>
    <tbody>
    {props.historyRecords.map(record => (
      <OrderHistoryRow key={record.updatedAt} tz={props.tz} record={record} />
    ))}
    </tbody>
  </Table>
);

export default OrderHistory;
